<template>
  <div v-if="showEmptyList">
    <s-empty-list
      class="empty-list"
      :empty-message="$t('messages.MA076.message')"
      :loading="loading"
    />
  </div>
  <div
    v-else
    class="alarms-accordion"
  >
    <div class="alarms-accordion__checkbox-area mb-2">
      <b-checkbox
        :checked="allAlarmsToggled"
        @change="toggleAllAlarms"
      />
      <span>{{ $t(markAllTitleHandler) }}</span>
    </div>
    <div class="alarms-accordion__alarms-wrapper">
      <div
        v-for="module in modulesAlarms"
        :key="module.module"
      >
        <accordion-panel
          :id="module.module"
          :collapsed.sync="module.collapsed"
        >
          <b-row
            class="pl-3"
            slot="title"
          >
            <b-checkbox
              :checked="isAlarmsFromModuleSelected(module)"
              @change="toggleAllAlarmsFromModule($event, module)"
            />
            <strong>
              {{ module.module }}
            </strong>
          </b-row>
          <b-checkbox-group
            class="alarms-accordion__checkbox-group ml-3"
            v-model="selectedAlarmProxy"
            text-field="name"
            value-field="id"
            stacked
            :options="module.alarms"
          />
        </accordion-panel>
      </div>
    </div>
  </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import AccordionPanel from '@/components/AccordionPanel';

export default {
  components: {
    AccordionPanel,
  },
  props: {
    selectedAlarms: {
      type: Array,
      default: () => ([]),
    },
    modulesAlarms: Array,
    loading: Boolean,
  },
  computed: {
    selectedAlarmProxy: {
      get() {
        return this.selectedAlarms;
      },
      set(value) {
        this.$emit('update:selected-alarms', value);
      },
    },
    showEmptyList() {
      return isEmpty(this.modulesAlarms);
    },
    markAllTitleHandler() {
      return this.allAlarmsToggled ? 'reports.alarms-and-warnings.filter.unmark-all' : 'reports.alarms-and-warnings.filter.mark-all';
    },
    allAlarmsToggled() {
      const allAlarms = [];
      if (this.showEmptyList) {
        return false;
      }
      this.modulesAlarms.forEach(module => module.alarms
        .forEach(alarm => allAlarms.push(alarm.id)));
      return allAlarms.every(item => this.selectedAlarms.includes(item));
    },
  },
  methods: {
    toggleAllAlarms(event) {
      if (this.showEmptyList) {
        return;
      }
      if (event) {
        this.modulesAlarms.forEach(module => module.alarms
          .forEach(alarm => this.addSelectedItem(alarm.id)));
        return;
      }
      this.modulesAlarms
        .forEach(module => module.alarms
          .forEach(alarm => this.removeSelectedItem(alarm.id)));
    },
    toggleAllAlarmsFromModule(event, module = []) {
      if (event) {
        module.alarms.forEach(it => this.addSelectedItem(it.id));
        return;
      }
      module.alarms.forEach(it => this.removeSelectedItem(it.id));
    },
    isAlarmsFromModuleSelected(module = []) {
      return module.alarms.every(item => this.selectedAlarms.includes(item.id));
    },
    addSelectedItem(selectedItem) {
      const itemExists = this.selectedAlarms.some(
        selectedAlarm => selectedAlarm === selectedItem,
      );
      if (itemExists) return;
      this.selectedAlarmProxy.push(selectedItem);
      this.$emit('update:selected-alarms', this.selectedAlarmProxy);
    },
    removeSelectedItem(selectedItem) {
      const itemIndex = this.selectedAlarms.findIndex(
        selectedAlarm => selectedAlarm === selectedItem,
      );
      this.selectedAlarmProxy.splice(itemIndex, 1);
      this.$emit('update:selected-alarms', this.selectedAlarmProxy);
    },
  },
};
</script>

<style scoped lang="sass">
  @import "src/styles/defaults/variables.sass"
  .alarms-accordion
    &__alarms-wrapper
      border: 1px solid $color-border-gray
      border-radius: 5px
      max-height: 300px
      overflow-y: auto
      overflow-x: hidden
    &__checkbox-area
      display: flex
      flex-wrap: nowrap
      margin-bottom: 3px
    &__alarms-header
      padding: 4px 10px
      display: flex
      align-items: center
    &__checkbox-group ::v-deep
      .custom-control.custom-checkbox
        margin-bottom: 5px
    ::v-deep .accordion-panel
      &__slot-container .custom-control-label
        font-weight: normal
      &__header
        padding: 4px 10px !important
        margin-bottom: 2px

  .empty-list
    margin-top: 5px
    border: 1px solid var(--color-border-dark)
    border-radius: 5px
</style>
